import type {LocationDetectedVariant} from '@yandex-delivery/types/logistic-dispatcher/external-api'

export const DEFAULT_CITIES: LocationDetectedVariant[] = [
  {
    address: 'Россия, Москва',
    geo_id: 213,
  },
  {
    address: 'Россия, Санкт-Петербург',
    geo_id: 2,
  },
  {
    address: 'Россия, Свердловская область, Екатеринбург',
    geo_id: 54,
  },
  {
    address: 'Россия, Республика Татарстан, Казань',
    geo_id: 43,
  },
]
